module.exports = __webpack_public_path__ + "static/media/debit_note_template.a3a0358d.docx";